import { render, staticRenderFns } from "./ChartCanvas.vue?vue&type=template&id=2931c450&scoped=true"
import script from "./ChartCanvas.vue?vue&type=script&lang=js"
export * from "./ChartCanvas.vue?vue&type=script&lang=js"
import style0 from "./ChartCanvas.vue?vue&type=style&index=0&id=2931c450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2931c450",
  null
  
)

export default component.exports